import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    REMOVE_AFSL: (afslNumber) => ({ afslNumber }),
    API: {
      REMOVE_AFSL: apiResourceActionCreator('removedAfslNumber')
    }
  }
})

export const apiAction = (authToken, afslNumber) => commonApiActions.authenticated.delete(USER_RESOURCE_ENDPOINT(RESOURCES.AfsLicences, afslNumber), authToken, actions.user.api.removeAfsl)

export function* removeAfsl({
  payload: {
    afslNumber
  }
}) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, afslNumber));
  }
}

const configuration = {
  name: 'removeAfsl',
  action: actions,
  sagas: removeAfsl,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      currentUserAfsLicences: [],
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/removeAfsl.js